/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next"
import React, { type ReactElement } from "react"

import ContainerPage from "../../components/ContainerPage"
import {
  TRANSLATION_INDEX_GLOBAL,
  TRANSLATION_INDEX_PERMISSION,
  TRANSLATION_INDEX_QUOTER
} from "../../config/translation"
import DataTable from "react-data-table-component"

import { ContainerTable } from "./_styles"
import { customStylesContext } from "../../styles/_styleDatatable"
import { useDispatch, useSelector } from "react-redux"
import SearchUserClientApp from "./forms/search/index"

import { NoData } from "../../components/NoData"
import { useGlobalContext } from "../../context/GlobalContext"
import "../../styles/styles.css"
import { useMobile } from "../../hook/useMobile"
import { getReportClearAll, getReportRankingCustomerRequest } from "../../state/modules/reportCommercial/actions"
import { reportCommercialSelector } from "../../state/modules/reportCommercial/_selectors"
import IconExcel from "../../components/Icons/IconExcel"
import { type IReportRankingCustomer } from "../../interfaces/IReportCustomer"
import { getCountryRequest } from "../../state/modules/customer/actions"

const ReportCustomerRankingPage = (): ReactElement => {
  const { t } = useTranslation()
  const isMobile = useMobile()
  const dispatch = useDispatch()
  const reportCustomer = useSelector(reportCommercialSelector)
  const [resetPage, setResetPage] = React.useState(false)

  const [dataFiltered, setDataFiltered] = React.useState<IReportRankingCustomer[]>()
  const [filters, setFilters] = React.useState<any>()
  const [clearFilter, setClearFilter] = React.useState(false)
  const [searchData, setSearchData] = React.useState(false)

  const [pagination, setPagination] = React.useState({ pagina: 1, registrosPorPagina: 10 })
  const { setLoadingContext, themeContext } = useGlobalContext()
  const { loadingContext } = useGlobalContext()

  const handlePageChange = (page: number): void => {
    setPagination({ ...pagination, pagina: page })
  }

  const handlePerRowsChange = (newPerPage: number, page: number): void => {
    setResetPage(true)
    setPagination({ registrosPorPagina: newPerPage, pagina: 1 })
  }
  const paginationComponentOptions = {
    rowsPerPageText: t(TRANSLATION_INDEX_GLOBAL.ROWS_PER_PAGE),
    rangeSeparatorText: t(TRANSLATION_INDEX_GLOBAL.OF),
    selectAllRowsItem: false,
    selectAllRowsItemText: t(TRANSLATION_INDEX_GLOBAL.ALL)
  }
  function formatNumberWithCommas(number: number): string {
    return number
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      .replaceAll(".", "--")
      .replaceAll(",", ".")
      .replaceAll("--", ",")
  }
  const columns = [
    {
      name: t(TRANSLATION_INDEX_QUOTER.COUNTRY),
      selector: (row: IReportRankingCustomer) => row.pais,
      width: isMobile ? "60px" : "9%",
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_QUOTER.CARRIER),
      selector: (row: IReportRankingCustomer) => row.transportista,
      width: isMobile ? "200px" : "12%",
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_QUOTER.COMPANY_NAME),
      selector: (row: IReportRankingCustomer) => `${row.cliente}`,
      width: isMobile ? "300px" : "20%",
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_QUOTER.WEIGHT),
      selector: (row: IReportRankingCustomer) => `${formatNumberWithCommas(Number(row.peso ?? 0)) ?? ""}`,
      width: isMobile ? "300px" : "8%",
      center: true,
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_QUOTER.PACKS),
      selector: (row: IReportRankingCustomer) => `${formatNumberWithCommas(Number(row.bultos ?? 0)) ?? ""}`,
      width: isMobile ? "300px" : "8%",
      center: true,
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_GLOBAL.AVERAGE),
      selector: (row: IReportRankingCustomer) => `${formatNumberWithCommas(Number(row.promedio ?? 0)) ?? ""}`,
      width: isMobile ? "300px" : "8%",
      center: true,
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_GLOBAL.PERCENT),
      selector: (row: IReportRankingCustomer) => `${formatNumberWithCommas(Number(row.porcentaje ?? 0)) ?? ""}`,
      width: isMobile ? "300px" : "8%",
      center: true,
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_GLOBAL.QUANTITY_OPERATIONS),
      selector: (row: IReportRankingCustomer) => `${formatNumberWithCommas(Number(row.cantOperaciones ?? 0)) ?? ""}`,
      width: isMobile ? "300px" : "8%",
      center: true,
      sortable: true
    },
    {
      name: t(TRANSLATION_INDEX_QUOTER.OPERATION_TYPE),
      selector: (row: IReportRankingCustomer) => `${row.tipoOperacion ?? ""}`,
      width: isMobile ? "300px" : "8%",
      center: true
    },
    {
      name: t(TRANSLATION_INDEX_QUOTER.TRANSPORT_MODE),
      selector: (row: IReportRankingCustomer) => `${row.modoTransporte ?? ""}`,
      width: isMobile ? "300px" : "8%",
      center: true
    }
  ]
  const getRequest = (): any => {
    return {
      anio: (filters?.anio && filters?.anio) > 0 ? filters?.anio : null,
      mesDesde: filters?.mesDesde?.value ?? null,
      mesHasta: filters?.mesHasta?.value ?? null,
      tipoOperacion: filters?.tipoOperacion?.value ?? null,
      modoTransporte: filters?.modoTransporte?.value ?? null,
      idsPaises: filters?.countries?.length > 0 ? filters?.countries?.map(item => item.value) ?? null : null,
      transportistas:
        filters?.transportistas?.length > 0 ? filters?.transportistas?.map(item => item.value) ?? null : null,
      paginado: pagination
    }
  }
  const handleExcel = (): void => {
    let queryParam = ""
    if (filters.anio) queryParam = queryParam + `anio=${filters?.anio}&`
    if (filters.mesDesde) queryParam = queryParam + `mesDesde=${filters?.mesDesde.value}&`
    if (filters.mesHasta) queryParam = queryParam + `mesHasta=${filters?.mesHasta.value}&`
    if (filters.modoTransporte) queryParam = queryParam + `modoTransporte=${filters?.modoTransporte.value}&`
    if (filters.tipoOperacion) queryParam = queryParam + `tipoOperacion=${filters?.tipoOperacion.value}&`
    if (filters.countries && filters.countries.length > 0)
      queryParam = queryParam + `idsPaises=${filters?.countries?.map(item => item.value).join(",")}&`
    if (filters.transportistas && filters.transportistas.length > 0)
      queryParam = queryParam + `transportistas=${filters?.transportistas?.map(item => item.value).join(",")}&`
    window.open(
      `${process.env.REACT_APP_API_URL}/api/backoffice/v1/reportes/rankingProcedencias/exportar?${queryParam}`
    )
  }
  const getData = (): void => {
    dispatch(getReportRankingCustomerRequest(getRequest()))
  }
  React.useEffect(() => {
    setLoadingContext(reportCustomer?.loading)
    setDataFiltered(reportCustomer?.reportRankingCustomer?.clientesRanking ?? [])
  }, [reportCustomer])

  React.useEffect(() => {
    if (searchData) {
      setLoadingContext(true)
      dispatch(getReportRankingCustomerRequest(getRequest()))
      setSearchData(false)
    }
  }, [searchData])
  React.useEffect(() => {
    if (resetPage) setResetPage(false)
  }, [resetPage])
  React.useEffect(() => {
    if (clearFilter) {
      setDataFiltered([])
      dispatch(getReportClearAll())
      setClearFilter(false)
    }
  }, [clearFilter])

  React.useEffect(() => {
    dispatch(getCountryRequest())
    return () => dispatch(getReportClearAll())
  }, [])
  React.useEffect(() => {
    if (filters) getData()
  }, [pagination])

  React.useEffect(() => {
    if (filters) {
      setResetPage(true)
      setPagination({ ...pagination, pagina: 1 })
    }
  }, [filters])
  return (
    <>
      <ContainerPage
        title={`${t(TRANSLATION_INDEX_PERMISSION.REPORTE_RANKING_CLIENTES)}`}
        actions={
          reportCustomer?.reportRankingCustomer && reportCustomer?.reportRankingCustomer?.clientesRanking?.length > 0
            ? [
                {
                  label: t(TRANSLATION_INDEX_GLOBAL.EXPORT),
                  icon: <IconExcel size={13} />,
                  permission: "*",
                  click: handleExcel
                }
              ]
            : []
        }
      >
        <>
          <ContainerTable themeContext={themeContext} opacity={1}>
            <SearchUserClientApp
              data={reportCustomer?.reportRankingCustomer}
              setDataFiltered={setDataFiltered}
              setFilters={setFilters}
              setSearchData={setSearchData}
              setClearFilter={setClearFilter}
            />
            <DataTable
              data={dataFiltered ?? []}
              theme="solarized"
              noDataComponent={
                <NoData
                  label={
                    loadingContext
                      ? ""
                      : filters
                      ? TRANSLATION_INDEX_GLOBAL.NO_DATA_2
                      : TRANSLATION_INDEX_GLOBAL.USE_SEARCH_TO_GET_RESULTS
                  }
                />
              }
              columns={columns}
              dense
              pagination
              paginationComponentOptions={paginationComponentOptions}
              striped
              customStyles={customStylesContext(themeContext)}
              paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
              paginationServer
              paginationTotalRows={reportCustomer?.reportRankingCustomer?.totalRegistros ?? 0}
              paginationDefaultPage={1}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationResetDefaultPage={resetPage}
            />
          </ContainerTable>
        </>
      </ContainerPage>
    </>
  )
}

export default ReportCustomerRankingPage
